import React from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import SectionTitle from '../sectionTitle/SectionTitle';

const AboutSeven = () => {
    return (
        <div className="eduvibe-home-four-about edu-about-area about-style-2 edu-section-gap bg-color-white">
            <div className="container eduvibe-animated-shape">
                <div className="row row--50">
                    <div className="col-lg-6">
                        <div className="about-image-gallery">
                            <div className="eduvibe-about-1-img-wrapper">
                                <img className="image-1" src="/images/about/about-07/about-image-01.png" alt="About Images" />
                                <span className="eduvibe-about-blur">
                                    <img src="/images/about/about-07/about-blur.png" alt="About Blur" />
                                </span>
                            </div>
                            <div className="circle-image-wrapper">
                                <img className="image-2" src="/images/about/about-07/about-image-02.png" alt="About Images" />
                                <div className="circle-image">
                                    <span></span>
                                </div>
                            </div>
                            <div className="finished-session">
                                <div className="inner">
                                    <div className="text">20+</div>
                                    <span className="finished-title">Years of <br /> Excellence</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="inner mt_md--40 mt_sm--40">
                            <SectionTitle
                                classes="text-start"
                                slogan="Our Story"
                                title="Two Decades of Excellence, Integrity &amp; Impact."
                            />
                            <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" animateOnce={true}>
                                <p className="description mt--40 mt_md--20 mt_sm--20">
                                    For the past 20 years, Green Cap High School has stood as a symbol of commitment, integrity, and educational excellence. Established with a clear vision to serve our community, our mission has always been to fulfill the evolving educational needs of society while shaping the future leaders of Pakistan.
                                </p>
                                <h6 className="subtitle mb--20">Trusted by Thousands of Families Since 2004</h6>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" className="about-feature-list" animateOnce={true}>
                                <div className="row g-5">
                                    <div className="col-lg-6">
                                        <div className="feature-style-3">
                                            <div className="feature-content">
                                                <h6 className="feature-title">9,000+</h6>
                                                <p className="feature-description">Alumni making meaningful contributions across Pakistan and around the world.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="feature-style-3">
                                            <div className="feature-content">
                                                <h6 className="feature-title">20 Years</h6>
                                                <p className="feature-description">Consistently placing students in Pakistan's leading colleges and universities.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" className="read-more-btn mt--40" animateOnce={true}>
                                <Link className="edu-btn" to="/contact-us">Get In Touch <i className="icon-arrow-right-line-right"></i></Link>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                    <div className="shape-image shape-image-1">
                        <img src="/images/shapes/shape-11-05.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-2">
                        <img src="/images/shapes/shape-08-01.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-3">
                        <img src="/images/shapes/shape-30.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape shape-1">
                        <span className="shape-dot"></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutSeven;
